import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const AttachmentIcon = createSvgIcon(
  <path
    d="M6.62618 13.3755L13.3763 6.62542M8.87621 3.25037L9.39709 2.64737C10.4521 1.59247 11.883 0.999895 13.375 1C14.8669 1.00011 16.2977 1.59288 17.3526 2.64793C18.4075 3.70297 19.0001 5.13386 19 6.62582C18.9999 8.11777 18.4071 9.54857 17.3521 10.6035L16.7513 11.1255M11.1262 16.7505L10.6796 17.3513C9.61197 18.4062 8.17154 18.9978 6.67062 18.9978C5.16971 18.9978 3.72928 18.4062 2.66163 17.3513C2.13525 16.8313 1.71734 16.2119 1.4321 15.5291C1.14687 14.8464 1 14.1138 1 13.3738C1 12.6339 1.14687 11.9013 1.4321 11.2185C1.71734 10.5357 2.13525 9.91638 2.66163 9.39633L3.25114 8.87545"
    {...strokeProps}
  />,
  { displayName: 'AttachmentIcon', viewBox: '0 0 20 20' }
);
